import { inject, Injectable } from '@angular/core';
import { TranslateDefaultParser } from '@ngx-translate/core';
import { HtmlSanitizerService } from './shared/services/html-sanitizer.service';

@Injectable()
export class ZiroTranslateParser extends TranslateDefaultParser {
  private _htmlSanitizerService = inject(HtmlSanitizerService);

  interpolate(expr: string, params?: any): string {
    if (params) {
      params = Object.entries(params).reduce((acc: { [k: string]: string }, [key, value]: [string, string]) => {
        acc[key] = this._htmlSanitizerService.escapeHtml(value);
        return acc;
      }, {});
    }
    return super.interpolate(expr, params);
  }
  getValue(target: any, key: string): any {
    return super.getValue(target, key);
  }
}
